import { render, staticRenderFns } from "./HousePinFAQ.vue?vue&type=template&id=b15f6ab0&"
import script from "./HousePinFAQ.vue?vue&type=script&lang=js&"
export * from "./HousePinFAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports